<template>
  <div class="my-6">
    <h5 class="mb-2">+ {{ $t('customForms.headers.addRemoveFieldsToTheForm') }}</h5>
    <v-autocomplete
      v-bind="$props"
      :loading="loading"
      :items="fields"
      v-model:search="searchStr"
      ref="dropdown"
      variant="outlined"
      hide-details
      item-title="label"
      data-testid="custom-forms-search-input"
      :menu-props="{ auto: true, closeOnClick: false, closeOnContentClick: false }"
      :placeholder="`${$t('customForms.placeholders.searchByFieldName')}...`">
      <template #selection></template>
      <template #item="{ item, props }">
        <v-list-item
          v-bind="props"
          :title="null"
          @click.stop="$emit(getFieldAction(item.raw), item.raw)">
          <template #prepend>
            {{ novaCore.truncateString(item.raw.label, 100) }}
          </template>
          <template #subtitle>
            <div class="ml-4">
              <v-icon size="small">mdi-{{ novaCore.customFieldIcons[item.raw.type] }}</v-icon>
              {{ translatedCustomFieldLabels[camelCase(item.raw.type)] }}
            </div>
          </template>
          <template #append>
            <v-btn
              variant="text"
              @click.stop="$emit(getFieldAction(item.raw), item.raw)"
              :color="fieldActions[getFieldAction(item.raw)].color">
              <v-icon class="mr-1" size="small">
                {{ fieldActions[getFieldAction(item.raw)].icon }}
              </v-icon>
              <span>
                {{ fieldActions[getFieldAction(item.raw)].text }}
              </span>
            </v-btn>
          </template>
        </v-list-item>
      </template>
      <template #append-item>
        <v-divider class="mb-3" />
        <v-list-item>
          {{ $t('customForms.messages.missingAField') }}
          <span
            class="text-secondary ml-2 cursor-pointer"
            @click="handleCreateField"
            :data-testid="`custom-forms-create-field-${app}`">
            <strong>{{ $t('customForms.buttons.createNew') }}</strong>
          </span>
        </v-list-item>
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
import { getTranslatedCustomFieldLabels } from '@nova/core';
import { camelCase } from 'lodash';

export default {
  props: {
    existingFields: {
      type: Array,
      default: () => []
    },
    app: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      fields: [],
      loading: false,
      searchStr: ''
    };
  },
  computed: {
    fieldActions() {
      return {
        remove: {
          text: this.$t('global.basicTerms.remove'),
          icon: 'mdi-sort-variant-remove',
          color: 'red'
        },
        add: {
          text: this.$t('global.basicTerms.add'),
          icon: 'mdi-plus',
          color: 'secondary'
        }
      };
    },
    translatedCustomFieldLabels() {
      return getTranslatedCustomFieldLabels();
    }
  },
  methods: {
    camelCase,
    handleCreateField() {
      this.$refs.dropdown.blur();
      this.$emit('create', this.searchStr);
    },
    getFieldAction(field) {
      const fieldExists = this.existingFields?.map(f => f.id).includes(field.id);
      return fieldExists ? 'remove' : 'add';
    },
    async getFields() {
      this.loading = true;
      try {
        const response = await axios.get('/custom-forms/field', {
          params: {
            sort: 'label,ASC'
          }
        });
        this.fields = (response?.data?.data || []).filter(
          field => field.type !== this.novaCore.CustomFieldType.Action
        );
      } finally {
        this.loading = false;
      }
    }
  },
  async beforeMount() {
    await this.getFields();
  },
  mounted() {
    Object.keys(this.sockets.actions).map(action => {
      this.$eventHub.$on(`${action}-FormField`, this.getFields);
      this.$eventHub.$on(`${action}-Field`, this.getFields);
    });
  },
  beforeUnmount() {
    Object.keys(this.sockets.actions).map(action => {
      this.$eventHub.$off(`${action}-FormField`);
      this.$eventHub.$off(`${action}-Field`);
    });
    this.searchStr = '';
  }
};
</script>
